// Hook - lista stopek skrzynki biezacego tradera.
// GET /api/ui/sales-crm/mailbox/signatures
// Sprint 3 v4.1.

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetMailSignaturesResponse } from 'api/types/signature';

export const MAIL_SIGNATURES_QUERY_KEY_BASE = 'sales-crm-mail-signatures' as const;
export const getMailSignaturesQueryKey = [MAIL_SIGNATURES_QUERY_KEY_BASE] as const;

const getMailSignatures = (): Promise<IGetMailSignaturesResponse> =>
  axios.get('/sales-crm/mailbox/signatures');

export const useGetMailSignatures = (
  options?: UseQueryOptions<IGetMailSignaturesResponse, IError>
) =>
  useQuery<IGetMailSignaturesResponse, IError>(getMailSignaturesQueryKey, getMailSignatures, {
    staleTime: 60_000,
    ...options
  });
